import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../app.constants';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { ActivitySearchModel } from '../models/activity-related/ActivitySearchModel';
import { ActivityCreateModel } from '../models/activity-related/ActivityCreateModel';

@Injectable()
export class ActivityWidgetContainerService {

    private actionUrl: string;
    private headers: Headers;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${_configuration.Server}api/ActivityWidget/`;
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public Get = (entityId: string): Observable<ActivitySearchModel[]> => {
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl + entityId, options).map(res => res.json());
    }

    public Create = (newActivity: ActivityCreateModel): Observable<Response> => {
        this.setHeaders();
        let options = new RequestOptions({ headers: this.headers });
        return this._http.post(this.actionUrl, JSON.stringify(newActivity), options).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/activity-widget-container/activity-widget-container.service.ts